import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'prepare-for-visit',
  styleUrl: 'prepare-for-visit.css',
})
export class PrepareForVisit {
  @Prop() shouldDisplayPrepareForVisit: boolean = false;

  render() {
    if (!this.shouldDisplayPrepareForVisit) {
      return;
    }
    return (
      <Host>
        <div class="@container">
          <div class="font-open-sans text-clrs-black flex flex-col justify-center py-6 mb-7 @xs:px-6 @md:px-12 rounded-lg shadow-drop">
            <div class="mb-1 font-extrabold text-lg font-montserrat @2xl:m-auto w-fit">Prepare For Your Visit</div>
            <div class="mb-4 @2xl:m-auto w-fit">To save time at the dealer, have these handy:</div>
            <div class="grid @xs:grid-cols-1 @2xl:grid-cols-2 @2xl:m-auto w-fit">
              <ul class="pl-7">
                <li class="pb-3">
                  <span class="font-bold">Your Offer Confirmation</span>
                </li>
                <li class="pb-3">
                  <span class="font-bold">Vehicle Registration</span>
                </li>
                <li class="pb-3">
                  <span class="font-bold">Driver's License or Govt. ID</span>
                </li>
              </ul>
              <ul class="pl-7">
                <li class="pb-3">
                  <span class="font-bold">Title, aka "Pink Slip"</span>
                  <div class="text-xs pl-8">if the vehicle is paid off</div>
                </li>
                <li class="pb-3">
                  <span class="font-bold">Payoff or Leasing Info</span>
                  <div class="text-xs pl-8">if the vehicle isn't paid off yet</div>
                </li>
                <li class="pb-3">
                  <span class="font-bold">All Keys, Remotes, and Manuals</span>
                </li>
              </ul>
            </div>
            <div class="text-left py-1">Remember to remove all your personal belongings, and if you’re not buying another car, arrange for a ride home.</div>
          </div>
        </div>
      </Host>
    );
  }
}
